import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Translate, withLocalize } from "react-localize-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import $ from "jquery";

import { BasePureComponent } from "common/components/Base";
import { showBusy, hideBusy } from "common/components/Busy/actions";
import { addAlert } from "common/components/Alerts/actions";
import { navigate } from "common/components/Navigate/actions";
import { toggle as toggleMenu } from "common/components/Menu/actions";
import { logout } from "common/entities/Security/actions";
import i18n from "./i18n.json";
import "./styles.scss";

/* The application's header. */
class Header extends BasePureComponent {
  constructor(props) {
    // parent
    super(props);

    // load translations
    props.addTranslation(i18n);
  }

  componentDidMount() {
    // parent
    super.componentDidMount();

    // the incredible shrinking header
    const toShrink = ["fsp-header", "fsp-header-text", "bm-menu-wrap"];
    $(document).on("scroll", function () {
      for (let i = 0; i < toShrink.length; i++) {
        if ($(document).scrollTop() > 100) {
          $(`.${toShrink[i]}`).addClass(`${toShrink[i]}-small`);
        } else {
          $(`.${toShrink[i]}`).removeClass(`${toShrink[i]}-small`);
        }
      }
    });
  }

  render() {
    // parent
    super.render();

    // render
    return (
      <div className="d-print-none">
        <div id="fsp-header" className="fsp-header fsp-background">
          <div className="fsp-header-container d-flex flex-row flex-grow">
            {this.props.administrator && (
              <div
                id="fsp-hamburger-container"
                className="fsp-hamburger-container"
              >
                <div
                  id="fsp-hamburger-icon"
                  className={
                    `fsp-hamburger-icon` +
                    (this.props.menuOpen ? " active" : "")
                  }
                  title={this.props.translate("header.menu.title")}
                  tabIndex="0"
                  aria-label={this.props.translate("header.menu.label")}
                  role="button"
                  aria-controls="navigation"
                  onClick={() => this.props.toggleMenu()}
                >
                  <div id="fsp-hamburger-bar1" className="fsp-hamburger-bar1" />
                  <div id="fsp-hamburger-bar2" className="fsp-hamburger-bar2" />
                  <div id="fsp-hamburger-bar3" className="fsp-hamburger-bar3" />
                </div>
              </div>
            )}
            <div className="flex-grow" />
            {process.env.REACT_APP_ENV && process.env.REACT_APP_ENV !== "prod" && (
              <div className="fsp-header-text align-middle">
                {process.env.REACT_APP_ENV &&
                  process.env.REACT_APP_ENV === "local" && (
                    <span title="You are currently testing in your local environment; this badge will not appear in production">
                      Local
                    </span>
                  )}
                {process.env.REACT_APP_ENV &&
                  process.env.REACT_APP_ENV === "qa" && (
                    <span title="You are currently testing in the QA environment; this badge will not appear in production">
                      QA
                    </span>
                  )}
                {process.env.REACT_APP_ENV &&
                  process.env.REACT_APP_ENV === "staging" && (
                    <span title="You are currently testing in the staging environment; this badge will not appear in production">
                      Staging
                    </span>
                  )}
              </div>
            )}
            <div className="flex-grow" />
            <div className="fsp-header-icons">
              {/* logout */}
              {this.props.administrator && (
                <span
                  id="fsp-header-icon-logout"
                  className="fsp-header-icon align-middle"
                >
                  <span
                    className="fsp-header-icon-text fsp-clickable"
                    title={this.props.translate("header.logout.title")}
                    onClick={() => {
                      // logout
                      this.props.logout();
                    }}
                  >
                    <Translate id="header.logout.label" />{" "}
                  </span>
                  <FontAwesomeIcon
                    icon="sign-out-alt"
                    className="fsp-clickable"
                    title={this.props.translate("header.logout.title")}
                    onClick={() => {
                      // logout
                      this.props.logout();
                    }}
                  />
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// map state to properties relevant to this component
const mapStateToProps = (state) => ({
  // menu open?
  menuOpen: state.menu.open,
});

// map dispatch function to callback props so that the component can invoke them
const mapDispatchToProps = (dispatch, ownProps) => ({
  // toggle menu
  toggleMenu: () => {
    dispatch(toggleMenu());
  },

  // go home
  home: () => {
    dispatch(navigate("home"));
  },

  // go to the profile
  profile: () => {
    dispatch(navigate("profile"));
  },

  // logout
  logout: () => {
    // show the busy indicator
    const busyId = dispatch(showBusy());

    // log the user out
    return dispatch(logout()).finally(() => {
      // get back to the login page
      dispatch(navigate("login"));

      // hide the busy indicator
      dispatch(hideBusy(busyId));

      // pop an alert
      dispatch(
        addAlert("success", ownProps.translate("header.loggedOut"), 5000)
      );
    });
  },
});

// turn this into a container component
Header = withLocalize(connect(mapStateToProps, mapDispatchToProps)(Header));

// set prop types and required-ness
Header.propTypes = { administrator: PropTypes.object };

// set default props
Header.defaultProps = {};

export default Header;
